import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

/* The page's own title, blurb and image for a link in a chat or comment. Posts
   store theirs when written; chats ask the server, which fetches each URL once
   and caches it for everyone — and this caches too, so re-renders don't ask. */
const cache = new Map();
const LINK_RE = /(https?:\/\/[^\s<>"')\]]+|www\.[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s<>"')\]]*)/i;

export function firstLink(text) {
  const m = (text || '').match(LINK_RE);
  if (!m) return null;
  const clean = m[0].replace(/[.,;:!?]+$/, '');
  return clean.startsWith('http') ? clean : `https://${clean}`;
}

const siteOf = (url) => url.replace(/^https?:\/\//, '').split(/[/?#]/)[0].replace(/^www\./, '');

export default function ChatLinkPreview({ text }) {
  const url = firstLink(text);
  const [card, setCard] = useState(url ? cache.get(url) : null);
  const [done, setDone] = useState(url ? cache.has(url) : true);
  useEffect(() => {
    if (!url) return undefined;
    if (cache.has(url)) { setCard(cache.get(url)); setDone(true); return undefined; }
    let live = true;
    api.linkPreview(url).then((c) => { cache.set(url, c || null); if (live) setCard(c || null); })
      .catch(() => {}).finally(() => { if (live) setDone(true); });
    return () => { live = false; };
  }, [url]);
  if (!url || !done) return null;
  const href = card?.url || url;
  return (
    <a className="fc-preview chat-preview" href={href} target="_blank" rel="noopener noreferrer nofollow" onClick={(e) => e.stopPropagation()}>
      {card?.image && <img src={card.image} alt="" loading="lazy" referrerPolicy="no-referrer" />}
      <span className="fc-preview-text">
        <span className="fc-preview-site">{card?.site || siteOf(url)}</span>
        {card?.title ? <b>{card.title}</b> : <span className="chat-preview-url">{url.replace(/^https?:\/\//, '')}</span>}
        {card?.description && <span className="fc-preview-desc">{card.description}</span>}
      </span>
    </a>
  );
}
